/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Barcode_Exists_UnknownInputs */

const vi_error_barcode_exists_unknown = /** @type {(inputs: Error_Barcode_Exists_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vạch này đang dùng cho một sản phẩm đang hoạt động khác. Gỡ mã vạch ở sản phẩm đó hoặc chuyển nó sang ngừng hoạt động rồi lưu lại.`)
};

/**

* @param {Error_Barcode_Exists_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_barcode_exists_unknown = /** @type {((inputs?: Error_Barcode_Exists_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Barcode_Exists_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_barcode_exists_unknown(inputs)
});